// MySQL normalizer — routes MySQL connections through the per-dialect
// tree-sitter grammar fork (resources/tree-sitter/mysql.wasm) instead of the
// legacy unified scanner. PRD: Ralph/SqlGrammar2/PRD.md Slice 4.5.
//
// Binds the `createForkNormalizer` factory (extracted in Slice 3.5 at n=3
// forks) to the MySQL parser singleton. n=4 confirmation that the factory
// composes without a dialect-specific options knob.

import { createForkNormalizer } from '../shared/createForkNormalizer';
import { getMysqlParser } from './parser';

const normalizer = createForkNormalizer({ engine: 'mysql', getParser: getMysqlParser });

export const buildParsedDocument = normalizer.buildParsedDocument;
export const getDocumentStructure = normalizer.getDocumentStructure;

export { setMysqlWasmLoader, getMysqlParser, __resetMysqlParserForTest } from './parser';
export type { MysqlWasmLoader } from './parser';
